import React from 'react';
import { Check } from 'lucide-react';
export function AboutSection() {
  const strengths = ['Equipo de profesionales especializados', 'Soluciones personalizadas según tus objetivos', 'Resultados medibles y orientados al ROI', 'Soporte técnico y asesoramiento continuo'];
  return <section id="about" className="py-16 md:py-24 bg-gray-50" data-id="element-14">
      <div className="container mx-auto px-4" data-id="element-15">
        <div className="flex flex-col md:flex-row items-center" data-id="element-16">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pr-10" data-id="element-17">
            <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Equipo de Sinapsis Digital" className="w-full h-auto rounded-lg shadow-lg" data-id="element-18" />
          </div>
          <div className="md:w-1/2" data-id="element-19">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-20">
              Sobre Nosotros
            </h2>
            <p className="text-lg text-gray-700 mb-6" data-id="element-21">
              Vaxtech Group SAS es una empresa legalmente constituida en
              Argentina, dedicada a brindar soluciones integrales de marketing
              digital y desarrollo tecnológico. Nuestro equipo de expertos
              combina creatividad y estrategia para transformar la presencia
              online de nuestros clientes y generar resultados tangibles.
            </p>
            <div className="space-y-3 mb-8" data-id="element-22">
              {strengths.map((strength, index) => <div key={index} className="flex items-start" data-id="element-23">
                  <Check className="text-green-500 w-5 h-5 mr-2 mt-1 flex-shrink-0" data-id="element-24" />
                  <p className="text-gray-700" data-id="element-25">{strength}</p>
                </div>)}
            </div>
            <a href="https://wa.me/5491150026793" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-700 transition-colors inline-block" data-id="element-26">
              Contáctanos
            </a>
          </div>
        </div>
      </div>
    </section>;
}